import axiosInstance from "@/app/api";
import {useEffect, useState} from "react";
import Loader from "../../dashboard/Loader";

type summary = {
  onwardPickup: number;
  onwardDrop: number;
  returnPickup: number;
  returnDrop: number;
  incompleteSwipes: number;
  totalStudents: number;
  unassigned: number;
  assigned: number;
  noSwipes: number;
};

export default function BusAttendanceAllBusSwipes({reportFilters}: any) {
  const busAttendanceAllBusSwipesData = async (
    chartdata: any
  ): Promise<any> => {
    return await axiosInstance()
      .post(`/api/reports/vehicle/rfidSwipes/summary/v2`, chartdata)
      .then((response: any) => {
        return response;
      })
      .catch((error: any) => {
        throw error;
      });
  };
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const run = async (from: any, to: any) => {
      setLoading(true);
      const Request = {
        from,
        to,
        offset: 1,
        instituteId: reportFilters?.instituteId,
        filters: {
          trackers: reportFilters?.trackers,
          branch: reportFilters?.branch
        }
      };
      const response = await busAttendanceAllBusSwipesData(Request);
      if (response?.data?.status !== "success") {
        return;
      }

      setChartsummary(response?.data?.data?.statistics.summary);

      setLoading(false);
    };

    if (
      reportFilters?.from &&
      reportFilters?.to
      // && reportFilters?.branch
    ) {
      run(reportFilters.from, reportFilters.to);
    }
  }, [reportFilters]);

  const [chartsummary, setChartsummary] = useState<summary>({
    onwardPickup: 0,
    onwardDrop: 0,
    returnPickup: 0,
    returnDrop: 0,
    incompleteSwipes: 0,
    totalStudents: 0,
    unassigned: 0,
    assigned: 0,
    noSwipes: 0
  });

  const assigned = chartsummary.assigned;
  const unassigned = chartsummary.unassigned;
  const total = chartsummary.totalStudents;
  const noSwipes = chartsummary.noSwipes;

  const assignedPercent = total ? ((assigned / total) * 100).toFixed(2) : 0;
  const unassignedPercent = total ? ((unassigned / total) * 100).toFixed(2) : 0;
  const noSwipesPercent = total ? ((noSwipes / total) * 100).toFixed(2) : 0;
  return (
    <>
      {/* main */}
      {loading ? (
        <div className="flex w-full justify-center">
          <Loader />
        </div>
      ) : (
        <>
          <div className="flex flex-row gap-2">
            {/* 1 */}
            <div className="rounded-xl border-1 border-gray-200 p-2">
              <div className=" mb-2 flex flex-row items-center gap-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#FFC7271A]">
                  <svg
                    width="19"
                    height="15"
                    viewBox="0 0 19 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.05552 0C4.65308 0 5.22615 0.237376 5.64868 0.659909C6.07122 1.08244 6.30859 1.65552 6.30859 2.25307C6.30859 2.85062 6.07122 3.4237 5.64868 3.84623C5.22615 4.26876 4.65308 4.50614 4.05552 4.50614C3.45797 4.50614 2.8849 4.26876 2.46236 3.84623C2.03983 3.4237 1.80246 2.85062 1.80246 2.25307C1.80246 1.65552 2.03983 1.08244 2.46236 0.659909C2.8849 0.237376 3.45797 0 4.05552 0ZM14.4196 0C15.0172 0 15.5903 0.237376 16.0128 0.659909C16.4353 1.08244 16.6727 1.65552 16.6727 2.25307C16.6727 2.85062 16.4353 3.4237 16.0128 3.84623C15.5903 4.26876 15.0172 4.50614 14.4196 4.50614C13.8221 4.50614 13.249 4.26876 12.8265 3.84623C12.4039 3.4237 12.1666 2.85062 12.1666 2.25307C12.1666 1.65552 12.4039 1.08244 12.8265 0.659909C13.249 0.237376 13.8221 0 14.4196 0ZM0 8.4124C0 6.75357 1.34621 5.40737 3.00503 5.40737H4.20761C4.6554 5.40737 5.08067 5.50594 5.46369 5.68055C5.42708 5.88333 5.41018 6.09455 5.41018 6.30859C5.41018 7.38443 5.88333 8.35044 6.62966 9.01228C6.62402 9.01228 6.61839 9.01228 6.60994 9.01228H0.59988C0.270368 9.01228 0 8.74191 0 8.4124ZM11.4146 9.01228C11.409 9.01228 11.4033 9.01228 11.3949 9.01228C12.144 8.35044 12.6144 7.38443 12.6144 6.30859C12.6144 6.09455 12.5947 5.88614 12.5609 5.68055C12.9439 5.50312 13.3691 5.40737 13.8169 5.40737H15.0195C16.6783 5.40737 18.0246 6.75357 18.0246 8.4124C18.0246 8.74473 17.7542 9.01228 17.4247 9.01228H11.4146ZM6.30859 6.30859C6.30859 5.59153 6.59345 4.90384 7.10048 4.3968C7.60752 3.88976 8.29522 3.60491 9.01228 3.60491C9.72934 3.60491 10.417 3.88976 10.9241 4.3968C11.4311 4.90384 11.716 5.59153 11.716 6.30859C11.716 7.02565 11.4311 7.71335 10.9241 8.22039C10.417 8.72743 9.72934 9.01228 9.01228 9.01228C8.29522 9.01228 7.60752 8.72743 7.10048 8.22039C6.59345 7.71335 6.30859 7.02565 6.30859 6.30859ZM3.60491 13.6677C3.60491 11.5949 5.28626 9.9135 7.35909 9.9135H10.6655C12.7383 9.9135 14.4196 11.5949 14.4196 13.6677C14.4196 14.0817 14.0845 14.4196 13.6677 14.4196H4.35687C3.94287 14.4196 3.60491 14.0845 3.60491 13.6677Z"
                      fill="#FFC727"
                    />
                  </svg>
                </div>
                <div className="text-medium font-semibold">Total Students</div>
              </div>
              <div className="ml-2 mt-3 font-bold">{total}</div>
            </div>
            {/* 2 */}
            <div className="rounded-xl border-1 border-gray-200 p-2">
              <div className=" mb-2 flex flex-row items-center gap-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#FFC7271A]">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 3C16 4.56875 14.1531 6.90938 13.3562 7.84375C13.2375 7.98125 13.0625 8.03438 12.9031 8H10C9.44687 8 9 8.44687 9 9C9 9.55313 9.44687 10 10 10H13C14.6562 10 16 11.3438 16 13C16 14.6562 14.6562 16 13 16H4.3625C4.63438 15.6906 4.96563 15.2938 5.3 14.85C5.49688 14.5875 5.7 14.3 5.89375 14H13C13.5531 14 14 13.5531 14 13C14 12.4469 13.5531 12 13 12H10C8.34375 12 7 10.6562 7 9C7 7.34375 8.34375 6 10 6H11.2437C10.5875 5.01562 10 3.88438 10 3C10 1.34375 11.3438 0 13 0C14.6562 0 16 1.34375 16 3ZM3.65937 15.2844C3.54062 15.4187 3.43438 15.5375 3.34375 15.6375L3.2875 15.7L3.28125 15.6938C3.09375 15.8375 2.825 15.8187 2.65625 15.6375C1.86875 14.7812 0 12.5781 0 11C0 9.34375 1.34375 8 3 8C4.65625 8 6 9.34375 6 11C6 11.9375 5.34062 13.0938 4.64062 14.0594C4.30625 14.5188 3.9625 14.9344 3.67812 15.2625L3.65937 15.2844ZM4 11C4 10.7348 3.89464 10.4804 3.70711 10.2929C3.51957 10.1054 3.26522 10 3 10C2.73478 10 2.48043 10.1054 2.29289 10.2929C2.10536 10.4804 2 10.7348 2 11C2 11.2652 2.10536 11.5196 2.29289 11.7071C2.48043 11.8946 2.73478 12 3 12C3.26522 12 3.51957 11.8946 3.70711 11.7071C3.89464 11.5196 4 11.2652 4 11ZM13 4C13.2652 4 13.5196 3.89464 13.7071 3.70711C13.8946 3.51957 14 3.26522 14 3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2C12.7348 2 12.4804 2.10536 12.2929 2.29289C12.1054 2.48043 12 2.73478 12 3C12 3.26522 12.1054 3.51957 12.2929 3.70711C12.4804 3.89464 12.7348 4 13 4Z"
                      fill="#FFC727"
                    />
                  </svg>
                </div>
                <div className="text-medium font-semibold">Trip Summary</div>
              </div>
              {/* 22 */}
              <div className="flex flex-row gap-5">
                {/* 1 */}
                <div>
                  <div className="mb-2 flex h-4 w-16 justify-center rounded-md bg-[#349C42] text-xs text-white">
                    ONWARD
                  </div>
                  <div className="flex flex-row gap-8">
                    <div className="flex flex-col gap-1">
                      <div className="text-xs font-semibold text-gray-600">
                        PICKUP
                      </div>
                      <div className=" font-semibold">
                        {chartsummary.onwardPickup}
                      </div>
                    </div>
                    <div className="flex flex-col gap-1">
                      <div className="text-xs font-semibold text-gray-600">
                        DROP
                      </div>
                      <div className="font-semibold">
                        {chartsummary.onwardDrop}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-2 border-r border-gray-200"></div>
                {/* 2 */}
                <div>
                  <div className="mb-2 flex h-4 w-14 justify-center rounded-md bg-[#2563EB] text-xs text-white">
                    RETURN
                  </div>
                  <div className="flex flex-row gap-8">
                    <div className="flex flex-col gap-1">
                      <div className="text-xs font-semibold text-gray-600">
                        PICKUP
                      </div>
                      <div className="font-semibold">
                        {chartsummary.returnPickup}
                      </div>
                    </div>
                    <div className="flex flex-col gap-1">
                      <div className="text-xs font-semibold text-gray-600">
                        DROP
                      </div>
                      <div className="font-semibold">
                        {chartsummary.returnDrop}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 3 */}
            <div className="rounded-xl border-1 border-gray-200 p-2">
              <div className=" mb-2 flex flex-row items-center gap-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#FFC7271A]">
                  <svg
                    width="18"
                    height="14"
                    viewBox="0 0 18 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 0C0.896875 0 0 0.896875 0 2V3H18V2C18 0.896875 17.1031 0 16 0H2ZM18 6H0V12C0 13.1031 0.896875 14 2 14H16C17.1031 14 18 13.1031 18 12V6ZM3.5 10H5.5C5.775 10 6 10.225 6 10.5C6 10.775 5.775 11 5.5 11H3.5C3.225 11 3 10.775 3 10.5C3 10.225 3.225 10 3.5 10ZM7 10.5C7 10.225 7.225 10 7.5 10H11.5C11.775 10 12 10.225 12 10.5C12 10.775 11.775 11 11.5 11H7.5C7.225 11 7 10.775 7 10.5Z"
                      fill="#FFC727"
                    />
                  </svg>
                </div>
                <div className="text-medium font-semibold">
                  Assigned vs Unassigned Swipes
                </div>
              </div>
              {/* 33 */}
              <div className="flex flex-row  justify-between gap-2">
                {/* 1 */}
                <div className="flex flex-col gap-1">
                  <div className="text-xs font-semibold text-gray-600">
                    ASSIGNED VEHICLE
                  </div>
                  <div className="font-semibold">{assigned}</div>
                  <div>
                    <h5 className="flex justify-end text-xs">
                      {assignedPercent}%
                    </h5>
                    <div className="h-1 w-36 rounded bg-[#dadadc]">
                      <div
                        className="h-1  rounded  bg-[#349C42]"
                        style={{width: `${assignedPercent}%`}}
                      ></div>
                    </div>
                  </div>
                </div>
                {/* 2 */}
                <div className="flex flex-row gap-1">
                  <div className="flex flex-col">
                    <div className="mb-2 text-xs font-semibold text-gray-600">
                      UNASSIGNED VEHICLE
                    </div>
                    <div className="font-semibold">{unassigned}</div>
                    <div>
                      <h5 className="flex justify-end text-xs">
                        {unassignedPercent}%
                      </h5>
                      <div className="h-1 w-36 rounded bg-[#dadadc]">
                        <div
                          className="h-1 rounded  bg-[#F28A03]"
                          style={{width: `${unassignedPercent}%`}}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 3 */}
                <div className="flex flex-col gap-1">
                  <div className="text-xs font-semibold text-gray-600">
                    NO SWIPES
                  </div>
                  <div className="font-semibold">{noSwipes}</div>
                  <div>
                    <h5 className="flex justify-end text-xs">
                      {noSwipesPercent}%
                    </h5>
                    <div className="h-1 w-36 rounded bg-[#dadadc]">
                      <div
                        className="h-1 rounded  bg-[#737373]"
                        style={{width: `${noSwipesPercent}%`}}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 4 */}
            <div className="rounded-xl border-1 border-gray-200 p-2">
              <div className=" mb-2 flex flex-row items-center gap-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-300">
                  <svg
                    width="18"
                    height="14"
                    viewBox="0 0 18 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 0C0.896875 0 0 0.896875 0 2V3H18V2C18 0.896875 17.1031 0 16 0H2ZM18 6H0V12C0 13.1031 0.896875 14 2 14H16C17.1031 14 18 13.1031 18 12V6ZM3.5 10H5.5C5.775 10 6 10.225 6 10.5C6 10.775 5.775 11 5.5 11H3.5C3.225 11 3 10.775 3 10.5C3 10.225 3.225 10 3.5 10ZM7 10.5C7 10.225 7.225 10 7.5 10H11.5C11.775 10 12 10.225 12 10.5C12 10.775 11.775 11 11.5 11H7.5C7.225 11 7 10.775 7 10.5Z"
                      fill="gray"
                    />
                  </svg>
                </div>
                <div className="text-medium font-semibold">
                  Incomplete Swipes
                </div>
              </div>
              <div className="flex flex-row items-center justify-center gap-2 rounded-l-md border-l-4 border-[#F59E0B] bg-[#FFFBEB80] p-2">
                <div>
                  <div className="flex h-8 w-8 items-center justify-center rounded-md bg-orange-200">
                    <svg
                      width="22"
                      height="18"
                      viewBox="0 0 24 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.9983 0C12.6639 0 13.278 0.351562 13.6155 0.928125L23.7405 18.1781C24.0826 18.7594 24.0826 19.4766 23.7498 20.0578C23.417 20.6391 22.7936 21 22.1233 21H1.87327C1.20296 21 0.57952 20.6391 0.246707 20.0578C-0.0861051 19.4766 -0.0814176 18.7547 0.256082 18.1781L10.3811 0.928125C10.7186 0.351562 11.3326 0 11.9983 0ZM11.9983 6C11.3748 6 10.8733 6.50156 10.8733 7.125V12.375C10.8733 12.9984 11.3748 13.5 11.9983 13.5C12.6217 13.5 13.1233 12.9984 13.1233 12.375V7.125C13.1233 6.50156 12.6217 6 11.9983 6ZM13.4983 16.5C13.4983 16.1022 13.3402 15.7206 13.0589 15.4393C12.7776 15.158 12.3961 15 11.9983 15C11.6004 15 11.2189 15.158 10.9376 15.4393C10.6563 15.7206 10.4983 16.1022 10.4983 16.5C10.4983 16.8978 10.6563 17.2794 10.9376 17.5607C11.2189 17.842 11.6004 18 11.9983 18C12.3961 18 12.7776 17.842 13.0589 17.5607C13.3402 17.2794 13.4983 16.8978 13.4983 16.5Z"
                        fill="#F59E0B"
                      />
                    </svg>
                  </div>
                </div>
                <div className="flex flex-col gap-1">
                  <div className="font-semibold">
                    {chartsummary.incompleteSwipes}
                  </div>
                  <div className="text-xs text-[#92400EB2]">
                    Missing Pickup or Drop Records
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* main */}
    </>
  );
}
